var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 937.52 676.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4175",
    "data-name": "Group 4175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_250_Highly_Skilled_Employees",
    "data-name": " 250 Highly Skilled Employees",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M676.74,4741.71H633.65v-6l22.76-25.29a54.63,54.63,0,0,0,7-9.33,15.55,15.55,0,0,0,1.92-7.43,11.81,11.81,0,0,0-3.12-8.45,10.91,10.91,0,0,0-8.31-3.29q-6.23,0-9.69,3.54t-3.45,9.87h-8.36q0-9.07,5.85-14.68t15.65-5.6q9.18,0,14.5,4.81t5.33,12.81q0,9.7-12.38,23.12l-17.61,19.11h33Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M698.68,4708.74l3.34-32.8h33.7v7.73h-26.6l-2,17.93a21.18,21.18,0,0,1,11-2.85q9,0,14.28,5.94t5.28,16.06q0,10.17-5.48,16t-15.34,5.85q-8.72,0-14.23-4.83t-6.28-13.37h7.91c.51,3.77,1.85,6.6,4,8.52a12.51,12.51,0,0,0,8.58,2.86,11.29,11.29,0,0,0,9.15-4q3.32-4,3.32-11,0-6.59-3.59-10.59a12.22,12.22,0,0,0-9.56-4q-5.46,0-8.58,2.4l-2.21,1.8Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M797.28,4713.66q0,14.68-5,21.82t-15.67,7.13q-10.53,0-15.58-7t-5.24-20.85v-11.16q0-14.49,5-21.54T776.5,4675q10.62,0,15.63,6.8t5.15,21Zm-8.36-11.43q0-10.6-3-15.47t-9.44-4.85q-6.42,0-9.35,4.83t-3,14.86V4715q0,10.66,3.1,15.74a10.22,10.22,0,0,0,9.37,5.08q6.2,0,9.19-4.78t3.14-15.09Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842,4706.43h18.34v7.91H842v20.78h-8.4v-20.78H815.29v-7.91h18.34v-19.19H842Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M963.79,4741.71h-8.72v-30.4H921.92v30.4h-8.67v-65.77h8.67v28.28h33.15v-28.28h8.72Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M987.18,4679.87a5,5,0,0,1,1.24-3.43,4.68,4.68,0,0,1,3.68-1.4,4.75,4.75,0,0,1,3.71,1.4,4.94,4.94,0,0,1,1.26,3.43,4.95,4.95,0,1,1-9.89,0Zm9,61.84h-8.36v-48.87h8.36Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1016.85,4716.87q0-11.43,5.28-18.18a16.92,16.92,0,0,1,14-6.76q8.94,0,13.95,6.33l.41-5.42h7.63v47.7q0,9.48-5.62,14.95T1037.4,4761a25.05,25.05,0,0,1-10.34-2.26,17.74,17.74,0,0,1-7.73-6.18l4.34-5q5.37,6.65,13.14,6.64,6.11,0,9.51-3.43t3.41-9.67v-4.2q-5,5.79-13.68,5.78a16.67,16.67,0,0,1-13.89-6.91Q1016.85,4728.8,1016.85,4716.87Zm8.4.95q0,8.27,3.39,13a11,11,0,0,0,9.48,4.72q7.91,0,11.61-7.18V4706q-3.84-7-11.52-7a11.12,11.12,0,0,0-9.53,4.74Q1025.25,4708.51,1025.25,4717.82Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1088.34,4698.75a17.81,17.81,0,0,1,14.46-6.82q15.5,0,15.63,17.48v32.3h-8.36v-32.34q0-5.28-2.42-7.82t-7.38-2.52a12.11,12.11,0,0,0-7.14,2.16,14.85,14.85,0,0,0-4.79,5.69v34.83H1080v-69.38h8.35Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1149.27,4741.71h-8.36v-69.38h8.36Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1187.88,4729.47l11.38-36.63h9l-19.65,56.41q-4.57,12.19-14.5,12.2l-1.58-.14-3.12-.58V4754l2.26.18a11.18,11.18,0,0,0,6.62-1.71q2.37-1.72,3.9-6.28l1.86-5-17.44-48.33h9.12Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1277.75,4712.4q-11.16-3.21-16.24-7.89a15,15,0,0,1-5.08-11.54,15.91,15.91,0,0,1,6.21-12.85q6.21-5.09,16.15-5.08a26.91,26.91,0,0,1,12.08,2.62,19.88,19.88,0,0,1,8.22,7.23A18.49,18.49,0,0,1,1302,4695h-8.71q0-6-3.8-9.41t-10.7-3.42q-6.42,0-10,2.83a9.45,9.45,0,0,0-3.59,7.85,8.48,8.48,0,0,0,3.41,6.81q3.42,2.79,11.61,5.09a54,54,0,0,1,12.83,5.09,19.38,19.38,0,0,1,6.86,6.48,16.47,16.47,0,0,1,2.24,8.72,15.36,15.36,0,0,1-6.23,12.8q-6.24,4.81-16.67,4.81a31,31,0,0,1-12.65-2.59,21.28,21.28,0,0,1-9-7.12,17.31,17.31,0,0,1-3.19-10.25h8.72a11.36,11.36,0,0,0,4.4,9.42q4.41,3.45,11.77,3.45,6.87,0,10.52-2.8a9.08,9.08,0,0,0,3.66-7.63,9,9,0,0,0-3.38-7.48Q1286.65,4715,1277.75,4712.4Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1334.83,4719.08l-5.23,5.47v17.16h-8.36v-69.38h8.36v42l4.47-5.37,15.22-16.08h10.16l-19,20.41,21.23,28.46h-9.81Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1377.38,4679.87a5,5,0,0,1,1.24-3.43,4.67,4.67,0,0,1,3.68-1.4,4.73,4.73,0,0,1,3.7,1.4,4.9,4.9,0,0,1,1.27,3.43,5.17,5.17,0,0,1-8.65,3.39A4.8,4.8,0,0,1,1377.38,4679.87Zm9,61.84h-8.36v-48.87h8.36Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1418.11,4741.71h-8.36v-69.38h8.36Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1449.81,4741.71h-8.36v-69.38h8.36Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1492.71,4742.61q-9.93,0-16.17-6.52t-6.23-17.46v-1.54a29.22,29.22,0,0,1,2.78-13,21.7,21.7,0,0,1,7.77-8.95,19.53,19.53,0,0,1,10.81-3.23q9.54,0,14.82,6.28t5.28,18v3.48h-33.1q.16,7.23,4.22,11.67a13.25,13.25,0,0,0,10.27,4.45,14.59,14.59,0,0,0,7.5-1.8,18.93,18.93,0,0,0,5.38-4.79l5.1,4Q1505,4742.62,1492.71,4742.61Zm-1-43.81a11.16,11.16,0,0,0-8.49,3.68q-3.43,3.69-4.24,10.32h24.48v-.63q-.36-6.37-3.44-9.87A10.48,10.48,0,0,0,1491.67,4698.8Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1528.66,4716.87q0-11.25,5.33-18.09a16.83,16.83,0,0,1,14-6.85q8.58,0,13.59,5.88v-25.48h8.36v69.38h-7.68l-.41-5.24q-5,6.15-14,6.14a16.68,16.68,0,0,1-13.85-6.95q-5.35-7-5.35-18.16Zm8.35.95q0,8.31,3.44,13a11.09,11.09,0,0,0,9.48,4.69,12.2,12.2,0,0,0,11.61-7.13v-22.45A12.28,12.28,0,0,0,1550,4699a11.15,11.15,0,0,0-9.57,4.74Q1537,4708.51,1537,4717.82Z",
    transform: "translate(-632.38 -4216.11)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M901.11,4842.36h-28.5v23.31h33.11v7.09H863.94V4807h41.33v7.1H872.61v21.18h28.5Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932.32,4823.89l.22,5.42q5.38-6.33,14.5-6.33,10.26,0,14,7.86a18.21,18.21,0,0,1,15.58-7.86q16.08,0,16.35,17v32.75h-8.35v-32.25q0-5.23-2.4-7.84t-8-2.59a11.08,11.08,0,0,0-7.72,2.77,11.29,11.29,0,0,0-3.57,7.48v32.43h-8.4v-32q0-10.66-10.43-10.66-8.22,0-11.25,7v35.68h-8.36v-48.87Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1056.07,4848.87q0,11.15-5.1,18a16.36,16.36,0,0,1-13.82,6.83q-8.91,0-14-5.65v23.53h-8.36v-67.66h7.63l.41,5.42q5.1-6.33,14.18-6.33a16.68,16.68,0,0,1,13.94,6.65q5.11,6.63,5.12,18.47Zm-8.35-.95q0-8.27-3.53-13.06a11.33,11.33,0,0,0-9.66-4.78,12.26,12.26,0,0,0-11.38,6.73v23.35a12.28,12.28,0,0,0,11.47,6.68,11.28,11.28,0,0,0,9.55-4.76Q1047.72,4857.31,1047.72,4847.92Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1085,4872.76h-8.36v-69.38H1085Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1105.43,4847.87a28.84,28.84,0,0,1,2.82-12.91,21,21,0,0,1,7.86-8.86,21.38,21.38,0,0,1,11.49-3.12q10,0,16.15,6.92t6.17,18.38v.59a29.11,29.11,0,0,1-2.73,12.8,20.75,20.75,0,0,1-7.82,8.83,21.64,21.64,0,0,1-11.68,3.17q-9.93,0-16.1-6.92t-6.16-18.29Zm8.4,1q0,8.13,3.77,13.05a12.78,12.78,0,0,0,20.21-.07q3.75-5,3.75-14,0-8-3.81-13a12.15,12.15,0,0,0-10.15-5,12,12,0,0,0-10,4.92C1115.09,4838.06,1113.83,4842.75,1113.83,4848.87Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1185.64,4860.52l11.38-36.63H1206l-19.64,56.41q-4.58,12.21-14.5,12.2l-1.58-.13-3.12-.59V4885l2.26.18a11.13,11.13,0,0,0,6.61-1.71q2.38-1.73,3.91-6.28l1.85-5-17.43-48.33h9.12Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1243,4873.67q-9.95,0-16.17-6.53t-6.23-17.46v-1.54a29.35,29.35,0,0,1,2.77-13,21.77,21.77,0,0,1,7.77-8.95,19.58,19.58,0,0,1,10.82-3.23q9.52,0,14.82,6.28t5.28,18v3.48H1228.9q.18,7.23,4.23,11.68a13.28,13.28,0,0,0,10.27,4.44,14.61,14.61,0,0,0,7.5-1.8,18.77,18.77,0,0,0,5.37-4.79l5.11,4Q1255.23,4873.67,1243,4873.67Zm-1-43.82a11.16,11.16,0,0,0-8.49,3.68q-3.43,3.69-4.25,10.32h24.49v-.63c-.25-4.25-1.39-7.53-3.44-9.87A10.51,10.51,0,0,0,1241.91,4829.85Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1301.21,4873.67q-9.95,0-16.17-6.53t-6.23-17.46v-1.54a29.35,29.35,0,0,1,2.77-13,21.77,21.77,0,0,1,7.77-8.95,19.58,19.58,0,0,1,10.82-3.23q9.52,0,14.82,6.28t5.28,18v3.48h-33.11q.18,7.23,4.22,11.68a13.31,13.31,0,0,0,10.28,4.44,14.61,14.61,0,0,0,7.5-1.8,18.77,18.77,0,0,0,5.37-4.79l5.11,4Q1313.49,4873.67,1301.21,4873.67Zm-1-43.82a11.16,11.16,0,0,0-8.49,3.68q-3.43,3.69-4.25,10.32h24.49v-.63c-.25-4.25-1.39-7.53-3.44-9.87A10.51,10.51,0,0,0,1300.17,4829.85Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1367.65,4859.8a6.16,6.16,0,0,0-2.56-5.26q-2.55-1.87-8.89-3.23a42.12,42.12,0,0,1-10.08-3.26,14.37,14.37,0,0,1-5.51-4.51,10.83,10.83,0,0,1-1.78-6.24,12.67,12.67,0,0,1,5.08-10.16q5.08-4.16,13-4.16,8.31,0,13.48,4.3a13.62,13.62,0,0,1,5.17,11h-8.4a7.56,7.56,0,0,0-2.91-5.92,11,11,0,0,0-7.34-2.48,11.39,11.39,0,0,0-7.14,2,6.23,6.23,0,0,0-2.58,5.19,5.06,5.06,0,0,0,2.4,4.56c1.59,1,4.48,2,8.65,2.94a45.16,45.16,0,0,1,10.14,3.34,14.87,14.87,0,0,1,5.76,4.68,11.48,11.48,0,0,1,1.87,6.66,12.48,12.48,0,0,1-5.24,10.5q-5.23,4-13.59,4a24.67,24.67,0,0,1-10.39-2.08,16.9,16.9,0,0,1-7.07-5.81,14,14,0,0,1-2.55-8.06h8.35a8.63,8.63,0,0,0,3.37,6.66,13,13,0,0,0,8.29,2.46,13.39,13.39,0,0,0,7.61-1.92A5.88,5.88,0,0,0,1367.65,4859.8Z",
    transform: "translate(-632.38 -4216.11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "onboarding"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    className: "cls-2",
    d: "M1043.84,4551.52H959.93a18,18,0,0,0-17,12H1060.8A18,18,0,0,0,1043.84,4551.52Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    className: "cls-2",
    cx: 368.33,
    cy: 80.74,
    r: 31.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    className: "cls-2",
    d: "M953.93,4443.63h6V4377.7h12v161.84h24V4431.61h12v107.93h24V4391.27a41.82,41.82,0,0,1,19.17-35.22l61-39.49a20.92,20.92,0,0,1-13.22-13.6l-43.17,26.57a41.93,41.93,0,0,1-22,6.22H995.91a54,54,0,0,0-54,54v42a12,12,0,0,0,12,12Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    className: "cls-2",
    cx: 596.51,
    cy: 29.82,
    r: 29.82
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    className: "cls-2",
    d: "M1271.37,4527.55h-83.92a18,18,0,0,0-18,18v18h119.88v-18A18,18,0,0,0,1271.37,4527.55Z",
    transform: "translate(-632.38 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    className: "cls-2",
    d: "M1247.38,4287.79H1118.51a9,9,0,0,0,0,18h62.94a18,18,0,0,1,18,18v191.81h24V4377.7h12v137.86h24v-197.8h12v89.91a18,18,0,0,0,18-18v-59.93A42,42,0,0,0,1247.38,4287.79Z",
    transform: "translate(-632.38 -4216.11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg6);
export default __webpack_public_path__ + "static/media/img-6.381a64543a32aff98b099ccc6f11bf98.svg";
export { ForwardRef as ReactComponent };